import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { DriverCard } from "@/features/resources/DriverCard";
import { CardNotFound, CardSkeleton } from "@/features/resources/CardScreens";
import { getDriver, resourcesKeys } from "@/features/resources/resources.api";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

const SCREEN_LABEL = "Back-office Driver Card";

export const Route = createFileRoute("/_shell/drivers/$id")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tms_drivers")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: DriverScreen,
});

function DriverScreen() {
  const { id } = Route.useParams();
  const { session } = Route.useRouteContext();
  const canEdit = session.roles.includes("admin") || hasModule(session, "tms_resources_write");
  // A remark by a working day: planning writes it as much as whoever manages the drivers (§6a).
  const canNote = canEdit || hasModule(session, "tms_planning_write");

  const query = useQuery({ queryKey: resourcesKeys.driver(id), queryFn: () => getDriver(id), retry: false });

  if (query.isPending) return <CardSkeleton screenLabel={SCREEN_LABEL} />;
  if (query.isError || !query.data) return <CardNotFound screenLabel={SCREEN_LABEL} />;

  return (
    <div className="wl-page" data-screen-label={SCREEN_LABEL}>
      <DriverCard driver={query.data} canEdit={canEdit} canNote={canNote} />
    </div>
  );
}
